import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import {
    ClientHierarchy,
    TileData,
    ClientHierarchyMain,
} from '../../../shared/interfaces/user-location';
import { ReusableFunctions } from '../../../shared/classes/reusable-functions';
import { ToastService } from '../../../shared/services/toast.service';
import { HierarchyService } from '../../services/hierarchy.service';
import { HierarchyEntity } from 'app/modules/settings/interfaces/hierarchy-data';

@Component({
    selector: 'hierarchy-setup',
    templateUrl: './hierarchy-setup.component.html',
    styleUrls: ['./hierarchy-setup.component.scss'],
})
export class HierarchySetupComponent implements OnInit {
    isRoleNameTooShort: boolean;
    isRoleNameInUse: boolean;
    hierarchyData: ClientHierarchy;
    entities: HierarchyEntity[];
    corporateHierarchy: TileData[];
    copyOfCorporateHierarchy: TileData[];
    sideSheetDialog: any;
    isDeleteButtonHidden = true;
    isSideSheetSaveBtnDisabled = true;
    isMainSaveBtnDisabled = true;
    isEditHierarchyDialogClose = true;
    sideSheetTitle: string = '';
    isMainButtonSetHidden = false;
    addTileposition: number;
    maxOrder: number;
    minOrder: number;
    originalRoleorder: number;
    roleOrdertoChange: number;
    @Input() activeCustomRoleNames: string[];
    @Output() setHierarchyLevels?: EventEmitter<TileData[]> = new EventEmitter<TileData[]>();
    @Output() sideSheetOpenStatus?: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() permenatlyHideMainButtonSet? = false;

    constructor(
        private _hierarchyService: HierarchyService,
        private reusableFunctions: ReusableFunctions,
        private toastService: ToastService
    ) {}

    ngOnInit() {
        this.getEntities();
        this.corporateHierarchy = [];
        this.resetFormData(null);

        if (this.permenatlyHideMainButtonSet) {
            this.isMainButtonSetHidden = true;
        }

        this.getCorporateHierarchy();
    }
    getCorporateHierarchy() {
        this._hierarchyService.getCorporateAllHierarchy().subscribe(
            (data) => {
                this.maxOrder = this.reusableFunctions.getMaxValue(data, 'roleOrder');
                this.minOrder = this.reusableFunctions.getMinValue(data, 'roleOrder');

                data.forEach((value, index) => {
                    this.initializecorporateHierarchy(value, index);
                });

                this.emitHierarchyLevels();
                this.sortcorporateHierarchy(this.corporateHierarchy);
                this.hideAllNewAddButton();
            },
            (err) => console.log(err)
        );
    }
    getEntities() {
        this._hierarchyService.getHierarchyEntities().subscribe(
            (entities) => {
                this.entities = entities;
            },
            (error) => {
                throw new Error(error);
            }
        );
    }

    emitHierarchyLevels() {
        this.setHierarchyLevels.emit(this.corporateHierarchy);
    }

    sortcorporateHierarchy(corporateHierarchy: TileData[]) {
        corporateHierarchy.sort((a, b) => b.roleOrder - a.roleOrder);
    }

    initializecorporateHierarchy(value: ClientHierarchy, index: number) {
        let isMaxLevel = false;
        let hideEditIcon = false;
        let hideTitleIcon = false;
        let fontIcon = 'fa-building';
        let fontSet = 'fa';

        if (value.roleOrder === this.maxOrder) {
            isMaxLevel = true;
            hideEditIcon = true;
            fontIcon = 'fa-university';
            value.description = null;
        }

        if (value.roleOrder === this.minOrder) {
            hideEditIcon = true;
            fontIcon = 'fa-user';
            value.description = null;
        }

        let tileName = null;
        if (value.roleName) {
            tileName = this.reusableFunctions.toCamelCase(value.roleName);
        }

        this.corporateHierarchy.push({
            isChanged: false,
            reference: value.reference,
            roleOrder: value.roleOrder,
            tileName: tileName,
            isTopLevel: isMaxLevel,
            tileData: {
                roleName: tileName,
                description: value.description,
                roleOrder: value.roleOrder,
                reference: value.reference,
                roleNameOriginal: tileName ? tileName.slice(0) : null,
                isActiveOriginal: value.isActive,
                descriptionOriginal: value.description ? value.description.slice(0) : null,
                roleOrderOriginal: value.roleOrder,
                isActive: value.isActive,
                isRoleInUse: value.isRoleInUse,
            },
            hideEditIcon: hideEditIcon,
            hideTitleIcon: hideTitleIcon,
            fontIcon: fontIcon,
            fontSet: fontSet,
        });
    }

    setButtonDissableStatus() {
        for (let hierarchy of this.corporateHierarchy) {
            let tile = hierarchy.tileData;
            if (this.isDataDifferent(tile)) {
                this.isSideSheetSaveBtnDisabled = false;
            } else {
                this.isSideSheetSaveBtnDisabled = true;
            }
        }
    }

    isDataDifferent(tile: ClientHierarchy): boolean {
        if (
            (tile.roleName != tile.roleNameOriginal ||
                tile.description != tile.descriptionOriginal ||
                tile.roleOrder != tile.roleOrderOriginal ||
                tile.isActive != tile.isActiveOriginal) &&
            tile.roleName &&
            tile.roleOrder
        ) {
            return true;
        } else {
            return false;
        }
    }

    hideAllNewAddButton() {
        const activeLevelList = this.corporateHierarchy.filter(
            (item) => item.tileData.isActive === true
        );

        let isAllBtnHidden = false;
        if (this.maxOrder === activeLevelList.length) {
            isAllBtnHidden = true;
            this.isSideSheetSaveBtnDisabled = true;
        }

        for (let hierarchy of activeLevelList) {
            const tile = this.corporateHierarchy.find(
                (item) => item.reference === hierarchy.reference
            );

            tile.hideAddButton = false;
            tile.hideCancelButton = false;

            if (isAllBtnHidden) {
                tile.hideAddButton = true;
                tile.hideCancelButton = true;
            }
        }
    }

    openDialog() {
        this.isEditHierarchyDialogClose = false;
        this.isMainButtonSetHidden = true;
        this.sideSheetOpenStatus.emit(true);
    }

    closeDialog() {
        this.isEditHierarchyDialogClose = true;

        if (!this.permenatlyHideMainButtonSet) {
            this.isMainButtonSetHidden = false;
        }
        this.sideSheetOpenStatus.emit(false);
    }

    openEditSidesheet(event, tile: TileData) {
        this.sideSheetTitle = 'Edit Hierarchy Level';
        this.isDeleteButtonHidden = this.doesLevelContainEntities(tile.roleOrder);
        this.openDialog();
        this.setActiveStatusForCurrentTiles(tile.tileData);
        this.closeNotUsingNewLevelTiles(tile.tileData, false);
        this.setDataForEdit(tile.tileData);
        this.isDeleteButtonHidden = this.doesLevelContainEntities(tile.roleOrder);
        this.setEditSaveButtonDissableStatus(this.hierarchyData);
        this.showHiddenAddButton();
    }
    doesLevelContainEntities(roleOrder: number): boolean {
        return this.entities.findIndex((x) => x.levelOrder === roleOrder) !== -1;
    }

    resetFormData(ref) {
        this.hierarchyData = {
            roleName: null,
            description: null,
            roleOrder: -1,
            reference: ref,
            roleNameOriginal: null,
            descriptionOriginal: null,
            roleOrderOriginal: -1,
            isActive: false,
            isActiveOriginal: false,
            isRoleInUse: true,
        };
    }

    setDataForEdit(tile: ClientHierarchy) {
        this.resetFormData(null);
        this.hierarchyData = Object.assign(
            {},
            this.corporateHierarchy.find((item) => item.reference === tile.reference).tileData
        );
    }

    openNewEntrySidesheet(tile: ClientHierarchy) {
        this.sideSheetTitle = 'Add New Hierarchy Level';
        this.resetFormData(null);
        this.hierarchyData.roleOrder = tile.roleOrder + 1;
        this.openDialog();
    }

    addNewButton(event, tile: TileData) {
        this.addTileposition = tile.roleOrder;
        this.openNewEntrySidesheet(tile.tileData);
        this.displayNewEntryTile(tile.tileData);
        this.resetEditActiveStatus();
        this.closeNotUsingNewLevelTiles(tile.tileData, true);
        this.isDeleteButtonHidden = true;
        this.hideAllNewAddButton();
        this.hideAddButton();
    }

    showHiddenAddButton() {
        const addButtonToShow = this.corporateHierarchy.find(
            (item) => item.roleOrder === this.addTileposition
        );
        const activeHierarchies = this.corporateHierarchy.filter(
            (item) => item.tileData.isActive === true
        );
        if (addButtonToShow && this.maxOrder != activeHierarchies.length) {
            addButtonToShow.hideAddButton = false;
        }
    }

    hideAddButton() {
        const addButtonToShow = this.corporateHierarchy.find(
            (item) => item.roleOrder === this.addTileposition
        );
        if (addButtonToShow) {
            addButtonToShow.hideAddButton = true;
        }
    }

    cancelButton($event, tile: ClientHierarchy) {
        this.closeDialog();
        this.hideNewEntryTile(tile);
        this.resetEditActiveStatus();
    }

    resetEditActiveStatus() {
        for (let tile of this.corporateHierarchy) {
            tile.activeShadow = 'regular-shadow';
        }
        this.showHiddenAddButton();
    }

    closeNotUsingNewLevelTiles(currentTile: ClientHierarchy, isAddnewClicked = false) {
        let otherTiles = this.corporateHierarchy;
        if (isAddnewClicked) {
            otherTiles = this.corporateHierarchy.filter(
                (item) => item.roleOrder != currentTile.roleOrder
            );
        }

        for (let tile of otherTiles) {
            let addNewTile = document.getElementById('add-new-dialog-' + tile.roleOrder);
            if (addNewTile) {
                addNewTile.style.display = 'none';
            }
        }
    }

    setActiveStatusForCurrentTiles(currentTile: ClientHierarchy) {
        currentTile.activeShadow = 'active-shadow';
        let otherTiles = this.corporateHierarchy.filter(
            (item) => item.roleOrder != currentTile.roleOrder
        );

        for (let tile of otherTiles) {
            tile.activeShadow = 'regular-shadow';
        }
    }

    displayNewEntryTile(tile: ClientHierarchy) {
        document.getElementById('add-new-dialog-' + tile.roleOrder).style.display = 'block';
    }

    hideNewEntryTile(tile: ClientHierarchy) {
        document.getElementById('add-new-dialog-' + tile.roleOrder).style.display = 'none';
    }

    getUpdatedHierarchiesAndSaveToDatabase() {
        let changedCorpHierarchy: ClientHierarchyMain[] = [];
        let changedCorpHierarchyAll: ClientHierarchy[] = [];

        for (let tile of this.corporateHierarchy) {
            if (this.isDataDifferent(tile.tileData)) {
                changedCorpHierarchy.push(
                    Object.assign(
                        {},
                        {
                            reference: tile.tileData.reference,
                            roleOrder: tile.tileData.roleOrder,
                            roleName: tile.tileData.roleName,
                            description: tile.tileData.description,
                            isActive: tile.tileData.isActive,
                        }
                    )
                );

                changedCorpHierarchyAll.push(Object.assign({}, tile.tileData));
            }
        }

        if (changedCorpHierarchy.length > 0) {
            this.saveUpdatedHierarchies(changedCorpHierarchy, changedCorpHierarchyAll);
        }
    }

    saveUpdatedHierarchies(
        changedCorpHierarchy: ClientHierarchyMain[],
        changedCorpHierarchyAll: ClientHierarchy[]
    ) {
        let isUpdated: boolean;
        this._hierarchyService.updateHierarchyLevels(changedCorpHierarchy).subscribe(
            (data) => {
                if (data > 0) {
                    isUpdated = true;
                } else {
                    isUpdated = false;
                }
                this.getEntities();
                this.updateOriginalData(isUpdated, changedCorpHierarchyAll);
                this.showMessage('', isUpdated);
            },
            (err) => console.log(err)
        );
    }

    cancelAllChanges(event) {
        this.cancelSidesheetChanges(event);
    }

    getNewReference(): number {
        let newreference: number;
        this.corporateHierarchy.forEach((level) => {
            if (
                level.reference < this.maxOrder &&
                level.reference > 1 &&
                !level.tileData.isActive &&
                !level.tileData.isRoleInUse
            ) {
                newreference = level.reference;
            }
        });
        return newreference;
    }

    checkForDuplicatesAndUpdate(tileDataToCheckDuplicate: TileData[], roleOrderToCheck: number) {
        if (roleOrderToCheck > this.minOrder && roleOrderToCheck < this.maxOrder) {
            let duplicateHierarchy = tileDataToCheckDuplicate.find(
                (item) => item.roleOrder === roleOrderToCheck
            );
            // TODO: Add codes to update, if more than one duplicate roleorders are present
            if (duplicateHierarchy) {
                let updatedHierarchy = this.copyOfCorporateHierarchy.find(
                    (item) => item.reference === duplicateHierarchy.reference
                );

                let nextRoleOrder = roleOrderToCheck + 1;

                if (nextRoleOrder < this.maxOrder && nextRoleOrder > this.minOrder) {
                    updatedHierarchy.roleOrder = nextRoleOrder;
                    updatedHierarchy.tileData.roleOrder = nextRoleOrder;
                    this.adjustAndReorder(updatedHierarchy);
                }
            }
        }
    }

    adjustAndReorder(updatedHierarchy: TileData) {
        let updatedReference = updatedHierarchy.reference;
        let updatedRoleOrder = updatedHierarchy.roleOrder;
        let tileDataToCheckDuplicate = this.copyOfCorporateHierarchy.filter(
            (item) => item.reference != updatedReference
        );

        this.checkForDuplicatesAndUpdate(tileDataToCheckDuplicate, updatedRoleOrder);
    }

    updateOriginalData(isUpdated: boolean, tiles: ClientHierarchy[]) {
        if (isUpdated) {
            this.corporateHierarchy = this.copyOfCorporateHierarchy;

            for (let tile of tiles) {
                let hierarchy = this.corporateHierarchy.find(
                    (item) => item.reference === tile.reference
                );
                hierarchy.tileData.isActive = true;
                hierarchy.isChanged = false;
                hierarchy.tileData.roleNameOriginal = tile.roleName ? tile.roleName.slice(0) : null;
                hierarchy.tileData.roleOrderOriginal = tile.roleOrder;
                hierarchy.tileData.descriptionOriginal = tile.description
                    ? tile.description.slice(0)
                    : null;
            }

            this.hideAllNewAddButton();
            this.emitHierarchyLevels();
        }
    }

    addChangesToTiles(event) {
        this.copyOfCorporateHierarchy = this.corporateHierarchy.filter(
            (item) => item.roleOrder != -1
        );

        if (!this.hierarchyData.reference) {
            this.hierarchyData.reference = this.getNewReference();
        }

        let corporateHierarchyLevel = this.copyOfCorporateHierarchy.find(
            (item) => item.reference === this.hierarchyData.reference
        );

        this.copyOfCorporateHierarchy.forEach((hierarchy) => {
            hierarchy.isChanged = false;
        });

        if (corporateHierarchyLevel) {
            corporateHierarchyLevel.reference = this.hierarchyData.reference;
            (corporateHierarchyLevel.isChanged = true),
                (corporateHierarchyLevel.roleOrder = this.hierarchyData.roleOrder);
            corporateHierarchyLevel.tileName = this.hierarchyData.roleName;
            corporateHierarchyLevel.tileData.reference = this.hierarchyData.reference;
            corporateHierarchyLevel.tileData.roleName = this.hierarchyData.roleName;
            corporateHierarchyLevel.tileData.roleOrder = this.hierarchyData.roleOrder;
            corporateHierarchyLevel.tileData.description = this.hierarchyData.description;
            corporateHierarchyLevel.tileData.isActive = true;
        } else {
            this.copyOfCorporateHierarchy.push({
                roleOrder: this.hierarchyData.roleOrder,
                hideEditIcon: false,
                hideTitleIcon: false,
                isChanged: true,
                tileName: this.hierarchyData.roleName,
                fontIcon: 'fa-building',
                fontSet: 'fa',
                tileData: {
                    roleName: this.hierarchyData.roleName,
                    roleOrder: this.hierarchyData.roleOrder,
                    description: this.hierarchyData.description,
                    reference: this.hierarchyData.reference,
                    isActive: true,
                    isRoleInUse: false,
                },
                reference: this.hierarchyData.reference,
            });
        }

        let updatedHierarchy = this.copyOfCorporateHierarchy.find(
            (item) => item.isChanged === true
        );
        this.adjustAndReorder(updatedHierarchy);
        this.sortcorporateHierarchy(this.copyOfCorporateHierarchy);
        this.closeNotUsingNewLevelTiles({} as ClientHierarchy, false);
        this.hideAllNewAddButton();
        this.resetFormData(null);
        this.closeDialog();

        if (this.permenatlyHideMainButtonSet) {
            this.getUpdatedHierarchiesAndSaveToDatabase();
        }
    }

    cancelSidesheetChanges(event) {
        this.resetFormData(null);
        this.closeDialog();
        this.setActiveStatusForCurrentTiles({} as ClientHierarchy);
        this.closeNotUsingNewLevelTiles({} as ClientHierarchy, false);
        this.showHiddenAddButton();
    }

    deleteSelectedLevel(event) {
        if (event === 'accept') {
            this._hierarchyService.deleteHierarchyLevels(this.hierarchyData).subscribe((result) => {
                if (result > 0 || result[0] > 0) {
                    let deletedLevel = this.corporateHierarchy.find(
                        (item) => item.reference === this.hierarchyData.reference
                    );
                    deletedLevel.tileData.isActive = false;
                    deletedLevel.isChanged = false;
                    this.activeCustomRoleNames.splice(
                        this.activeCustomRoleNames.findIndex(
                            (x) => x.toLowerCase() === this.hierarchyData.roleName.toLowerCase()
                        ),
                        1
                    );
                    this.resetFormData(null);
                    this.closeDialog();
                    this.hideAllNewAddButton();
                    this.corporateHierarchy = [];
                    this.getCorporateHierarchy();
                    this.getEntities();
                    this.toastService.success('Level deleted.');
                } else {
                    this.toastService.warning('Problem deleting level.');
                }
            });
        }
    }

    showMessage(msgType: string, isSuccess: boolean) {
        if (isSuccess) {
            this.toastService.success('Successfully saved!');
            this.emitHierarchyLevels();
        } else {
            this.toastService.warning('Problem updating levels.', {
                timeout: 0,
            });
        }
    }

    dataChanged() {
        this.setEditSaveButtonDissableStatus(this.hierarchyData);
    }

    setEditSaveButtonDissableStatus(tileData: ClientHierarchy) {
        if (this.isDataDifferent(tileData) && this.isRoleNameValid(tileData.roleName)) {
            this.isSideSheetSaveBtnDisabled = false;
        } else {
            this.isSideSheetSaveBtnDisabled = true;
        }
    }
    isRoleNameValid(roleName: string) {
        if (roleName.length < 3) {
            this.isRoleNameTooShort = true;
            return false;
        } else {
            this.isRoleNameTooShort = false;
        }
        if (!this.isRoleNameUnique(roleName)) {
            this.isRoleNameInUse = true;
            return false;
        } else {
            this.isRoleNameInUse = false;
        }
        return true;
    }
    isRoleNameUnique(roleName: string) {
        return (
            this.activeCustomRoleNames.findIndex(
                (name) => name.toLowerCase() === roleName.toLowerCase()
            ) === -1
        );
    }

    saveNewHieararchyToDatabase(event) {}
}
